/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckInvestments } from './deck-investments';

export interface PaginatedDeckInvestmentsList {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: Array<DeckInvestments>;
}
